import { ContactFormConfig, FormStep } from '../types/ContactForm';

export interface StepValidationResult {
    isValid: boolean;
    emptySteps: Array<{ stepNumber: number; stepTitle: string }>;
}

export const validateSteps = (config: ContactFormConfig): StepValidationResult => {
    const steps = config.steps || [];
    const formFields = config.formFields || [];
    const emptySteps: Array<{ stepNumber: number; stepTitle: string }> = [];

    steps.forEach((step: FormStep, index: number) => {
        const stepNumber = index + 1;
        const fieldsInStep = formFields.filter(field => (field.step || 1) === stepNumber);

        if (fieldsInStep.length === 0) {
            emptySteps.push({
                stepNumber,
                stepTitle: step.title || `Schritt ${stepNumber}`
            });
        }
    });

    return {
        isValid: emptySteps.length === 0,
        emptySteps
    };
};
